import { render } from "./VideoAdvertises.vue?vue&type=template&id=e4485532"
import script from "./VideoAdvertises.vue?vue&type=script&lang=js"
export * from "./VideoAdvertises.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__